import { FC, useContext } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import styled from 'styled-components';

import PrimaryButton from '@/components/Buttons/PrimaryButton';
import ContainerSmall from '@/components/ContainerSmall/ContainerSmall';
import StoriesSlider from '@/components/StoriesSlider/StoriesSlider';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const SuccessStories: FC<any> = ({ data }) => {
	const { lang } = useContext(GlobalContext);

	return (
		<Section>
			<ContainerSmall>
				<ScrollAnimation animateOnce animateIn="fadeInUp" duration={0.7}>
					<Title>
						{translate(lang, {
							en: 'Success stories',
							ru: 'Истории успеха',
							ua: 'Історії успіху',
						})}
					</Title>
				</ScrollAnimation>

				<ScrollAnimation animateOnce animateIn="fadeInUp" duration={0.7}>
					<StoriesSlider slides={data} />
				</ScrollAnimation>

				<ScrollAnimation animateOnce animateIn="fadeInUp" duration={0.7}>
					<ButtonWrapper>
						<PrimaryButton
							width="wide"
							href="/success-stories"
							text={translate(lang, {
								en: 'Read more stories',
								ru: 'Узнать больше',
								ua: 'Дізнайтеся більше',
							})}
						/>
					</ButtonWrapper>
				</ScrollAnimation>
			</ContainerSmall>
		</Section>
	);
};

const Section = styled.section`
	margin-bottom: 220px;

	@media (max-width: 600px) {
		margin-bottom: 80px;
	}
`;

const Title = styled.h2`
	display: block;
	max-width: 485px;
	font-size: 65px;
	line-height: 60px;
	font-family: var(--font-sans);

	font-weight: var(--font-bold);
	color: var(--color-purple);
	margin-bottom: 56px;
	padding-left: 15px;

	@media (max-width: 833px) {
		display: block;
		margin-bottom: 36px;
		font-size: 50px;
		line-height: 50px;
	}

	@media (max-width: 600px) {
		max-width: 149px;
		font-size: 40px;
		line-height: 40px;
		padding-left: 15px;
	}
`;

const ButtonWrapper = styled.div`
	button {
		display: block;
		margin: 0 auto;
		margin-top: 40px;
		padding: 0 15px;

		@media (max-width: 833px) {
			margin-top: 40px;
		}
	}
`;

export default SuccessStories;
